import React from "react";
import {
  Spin,
  Divider
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../Dashboard/Filters";
import GraficoTipoComprobante from "./GraficoTipoComprobante";
import GraficoEstablecimientoRanking from "./GraficoEstablecimientoRanking";
import GraficoVendedorEstado from "./GraficoVendedorEstado";
import GraficoVendedorRanking from "./GraficoVendedorRanking";
import GraficoClienteRanking from "./GraficoClienteRanking";
import GraficoProductoRanking from "./GraficoProductoRanking";
import GraficoClienteSoles from "./GraficoClienteSoles";
import GraficoClienteCantidad from "./GraficoClienteCantidad";
import GraficoProductoSoles from "./GraficoProductoSoles";
import GraficoProductoCantidad from "./GraficoProductoCantidad";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component  {
  constructor(props)  {
    super(props);
    this.state = {
      loading: true,
      filter: {
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
      },
      graficoTipoComprobante: {
        series: [],
        tiposcomprobante: [],
      },
      graficoEstablecimientoRanking: {
        series: [],
        establecimientos: [],
      },
      graficoVendedorEstado: {
        series: [],
        vendedores: [],
      },
      graficoVendedorRanking: {
        series: [],
        vendedores: [],
      },
      ///CLIENTE
      graficoClienteRanking: {
        series: [],
        clientes: [],
      },
      graficoClienteSoles: {
        series: [],
        clientes: [],
      },
      graficoClienteCantidad: {
        series: [],
        clientes: [],
      },
      ///PRODUCTO
      graficoProductoRanking: {
        series: [],
        productos: [],
      },
      graficoProductoSoles: {
        series: [],
        productos: [],
      },
      graficoProductoCantidad: {
        series: [],
        productos: [],
      },
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleClearFilters = () => {
    
    this.setState({
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
    });
  };

  handleGenerateReport = async (filter) => {
    this.setState({
      loading: true,
    });
    const response = await comprobanteService.dashboard(filter);
    if (response !== undefined) 
    this.setState({
      graficoTipoComprobante: {
        series: response.dataGraficoTipoComprobante,
        tiposcomprobante: response.dataTipoComprobante,
      },
      graficoEstablecimientoRanking: {
        series: response.dataGraficoEstablecimientoRanking,
        establecimientos: response.dataEstablecimientos,
      },
      graficoVendedorEstado: {
        series: response.dataGraficoVendedorEstado,
        vendedores: response.dataVendedor,
      },
      graficoVendedorRanking: {
        series: response.dataGraficoVendedorRanking,
        vendedores: response.dataVendedor,
      },

      graficoProductoRanking: {
        series: response.dataGraficoProductoRanking,
        productos: response.dataProductosOrderTotal,
      },
      graficoProductoSoles: {
        series: response.dataGraficoProductoSoles,
        productos: response.dataProductosOrderTotal,
      },
      graficoProductoCantidad: {
        series: response.dataGraficoProductoCantidad,
        productos: response.dataProductosOrderCantidad,
      },

      graficoClienteRanking: {
        series: response.dataGraficoClienteRanking,
        clientes: response.dataClienteOrderTotal,
      },
      graficoClienteSoles: {
        series: response.dataGraficoClienteSoles,
        clientes: response.dataClienteOrderTotal,
      },
      graficoClienteCantidad: {
        series: response.dataGraficoClienteCantidad,
        clientes: response.dataClienteOrderCantidad,
      },
      loading: false
    });
  };

  async componentDidMount() {
    await this.handleGenerateReport(this.state.filter);
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Dashboard"
          onClearFilters={this.handleClearFilters}
          onSearch={() => this.handleGenerateReport(this.state.filter)}
        />
        <Divider />
        <Filters filter={this.state.filter} onChange={this.handleChange} />
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
          <div className="row">
            <div className="col-md-6 form-group">
              <GraficoTipoComprobante
                series={this.state.graficoTipoComprobante.series}
                tiposcomprobante={
                  this.state.graficoTipoComprobante.tiposcomprobante
                }
              />
            </div>
            <div className="col-md-6 form-group">
              <GraficoEstablecimientoRanking
                series={this.state.graficoEstablecimientoRanking.series}
                establecimientos={
                  this.state.graficoEstablecimientoRanking.establecimientos
                }
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <GraficoVendedorEstado
                series={this.state.graficoVendedorEstado.series}
                vendedores={this.state.graficoVendedorEstado.vendedores}
              />
            </div>
            <div className="col-md-6 form-group">
              <GraficoVendedorRanking
                series={this.state.graficoVendedorRanking.series}
                vendedores={this.state.graficoVendedorRanking.vendedores}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <GraficoClienteSoles
                series={this.state.graficoClienteSoles.series}
                clientes={this.state.graficoClienteSoles.clientes}
              />
            </div>
            <div className="col-md-6 form-group">
              <GraficoClienteCantidad
                series={this.state.graficoClienteCantidad.series}
                clientes={this.state.graficoClienteCantidad.clientes}
              />
            </div>
          </div>

          <GraficoClienteRanking
            series={this.state.graficoClienteRanking.series}
            clientes={this.state.graficoClienteRanking.clientes}
          />

          <div className="row">
            <div className="col-md-6 form-group">
              <GraficoProductoSoles
                series={this.state.graficoProductoSoles.series}
                productos={this.state.graficoProductoSoles.productos}
              />
            </div>
            <div className="col-md-6 form-group">
              <GraficoProductoCantidad
                series={this.state.graficoProductoCantidad.series}
                productos={this.state.graficoProductoCantidad.productos}
              />
            </div>
          </div>

          <GraficoProductoRanking
            series={this.state.graficoProductoRanking.series}
            productos={this.state.graficoProductoRanking.productos}
          />
        </Spin>
      </div>
    );
  }
}
